
import { useState } from "react";
import { TicketModal } from "@/components/TicketModal";
import { HeroSection } from "@/components/home/HeroSection";
import { MainCarousel } from "@/components/home/MainCarousel";
import { Header } from "@/components/home/Header";
import type { Event } from "@/types";

interface ContentSectionProps {
  backgroundImages: string[];
  selectedEvent: Event | null;
  modalOpen: boolean;
  onModalClose: () => void;
}

export const ContentSection = ({ 
  backgroundImages, 
  selectedEvent, 
  modalOpen, 
  onModalClose 
}: ContentSectionProps) => {
  return (
    <div className="relative z-20 min-h-screen flex flex-col">
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div className="h-[45vh]">
        <HeroSection backgroundImages={backgroundImages} />
      </div>
      
      {/* Main Carousel */}
      <div className="flex-1 relative">
        <MainCarousel />
      </div>
      
      <TicketModal
        event={selectedEvent}
        isOpen={modalOpen}
        onClose={onModalClose}
      />
    </div>
  );
};
